import React from 'react';
import ReactDOM from 'react-dom/client';

// Fonts loaded locally, not from Google Fonts. Inter stays until the private screens move to
// V3; the two families never coexist on one screen.
import '@fontsource-variable/instrument-sans';
import '@fontsource-variable/inter';

import App from './app/App';

import './index.scss';
import './login.scss';
import './tailwind.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
